import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Toggle } from "@/components/shared/Toggle";
import { Txt } from "@/components/Txt";

export default function ModulesPage() {
  const { persona, fetchMe } = useAuth();
  const [modules, setModules] = useState([]);
  const load = useCallback(async () => {
    const m = await api.get("/modules");
    setModules(m.data.modules);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (mod) => {
    try {
      await api.put(`/modules/${mod.module_id}`, { enabled: !mod.enabled });
      toast.success(`${mod.name} ${!mod.enabled ? "enabled" : "disabled"}`);
      await load();
      await fetchMe(persona);
    } catch (e) { toast.error("Could not update module"); }
  };

  return (
    <div>
      <h1 className="font-zilla text-3xl sm:text-4xl font-semibold mb-1"><Txt id="modules.title" screen="Modules">Modules</Txt></h1>
      <p className="text-[17px] text-ink/70 mb-5"><Txt id="modules.subtitle" screen="Modules">Switch whole features on or off, system-wide.</Txt></p>
      <div className="bg-warm-cream border border-ink/15 rounded-lg p-4 mb-5 text-[15px] text-ink/75">
        <Txt id="modules.banner" screen="Modules">Switching a module off hides it from every navigation and screen for every role, keeps its data, and brings it back unchanged when re-enabled. Donations is the first live module.</Txt>
      </div>
      <div className="space-y-3" data-testid="modules-list">
        {modules.length === 0 && (
          <div className="bg-cream border border-ink/15 rounded-xl p-8 text-center text-ink/55">
            <Txt id="modules.empty" screen="Modules">No modules registered yet. Features register here as they ship.</Txt>
          </div>
        )}
        {modules.map((m) => (
          <div key={m.module_id} className="bg-cream border border-ink/15 rounded-xl p-5 flex items-center justify-between gap-4" data-testid={`module-${m.module_id}`}>
            <div>
              <div className="text-[16px] font-semibold">{m.name}</div>
              <div className="text-[14px] text-ink/60">{m.description}</div>
            </div>
            <Toggle testid={`module-toggle-${m.module_id}`} checked={m.enabled} onChange={() => toggle(m)} />
          </div>
        ))}
      </div>
    </div>
  );
}
